import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ModelAndDealerService } from "src/services/model-and-dealer.service";

@Component({
  selector: "vw-typeahead",
  templateUrl: "./typeahead.component.html",
})
export class TypeaheadComponent {
  @Input() id?: string;
  @Input() label?: string;
  @Input() labelClass?: string;
  @Input() formControlProp?: string | number;
  @Input({ required: true }) parentForm!: FormGroup;
  @Input() clearButton?: boolean;
  @Input() buttonText?: string;
  @Input() buttonDisabled?: boolean;
  @Input({ required: true }) items!: any[];
  @Input() template: TemplateRef<any> | null = null;
  @Input() placeholder: string = "";
  @Input() open?: boolean;
  @Input({ required: true }) noMatchesTranslationKey!: string;
  @Input() loading?: boolean;
  @Input() showMapToggle?: boolean;

  @Output() clear$ = new EventEmitter<void>();
  @Output() buttonClick$ = new EventEmitter<void>();
  @Output() itemSelected$ = new EventEmitter<any>();

  constructor(private modelAndDealerService: ModelAndDealerService) {}

  clear(): void {
    this.clear$.emit();
  }

  buttonClick(): void {
    this.buttonClick$.emit();
  }

  itemSelected(item: any): void {
    this.itemSelected$.emit(item);
  }

  openSelectDealerModal(): void {
    this.modelAndDealerService.openSelectDealer(this.parentForm.value.dealer);
  }
}
